<template>
  <span>
    <i class="fas fa-sort-up" :class="{'active': order === 'asc'}"></i>
    <i class="fas fa-sort-down" :class="{'active': order === 'desc'}"></i>
  </span>
</template>

<script>
export default {
  name: 'i-sort-indicator',
  props: {
    order: {
      type: String,
      required: false,
      validator(value) {
        return ['asc', 'desc'].includes(value);
      },
    },
  },
};
</script>
<style scoped lang='scss'>
  span {
    display: inline-block;
    width: 10px;
    height: 12px;
    position: relative;
    i {
      position: absolute;
      left: 0;
      color: $i-list-border-color;
      &.active {
        color: $blue;
      }
    }
  }
</style>
